export const REDUCER_PATHS = {
  AUTH: "auth",
  TOKEN: "token",
  USERS: "users",
  MASTER: "master",
  PROFILE: "profile",
  SETTINGS: "settings",
  ROLE: "role",
  EMAIL_TEMPLATES: "emailTemplates",
  BLOG: "blog",
  FILTER: "filter",
  SUPPORT: "support",
  CATEGORY: "category",
  CLUBS: "clubs",
  REPORTS: "reports",
  BRAND: "brand",
  MANAGE_PROMOTION: "managePromotion",
  DASHBOARD: "dashboard",
  FOURVENUES: "fourvenues",
};

export const REDUCER_TAGS = {
  POSTS: "Posts",
  PROFILE: "Profile",
  SETTINGS: "settings",
  USERS: "users",
};
